<script>
	// Vous pouvez ajouter ici des scripts ou importer des composants
</script>

<main class="vh-100 flex items-center justify-center">
	<div class="tc white">
		<h1 class="f2 fw6">Tableau de bord</h1>
		<p class="f4">Bienvenue sur votre tableau de bord !</p>
		<p class="f4">En cours de développement !</p>
	</div>
</main>

<style>
	main {
		background: linear-gradient(to bottom right, #2c7cc9 50%, #d1e51e);
		color: white;
	}
</style>